/** Domains not allowed for self-service sign-up (exact match on host after @). */
export const BLOCKED_SIGNUP_EMAIL_DOMAINS = ['my-cpe.com'];

export function isSignupEmailDomainBlocked(email) {
  if (!email || typeof email !== 'string') return false;
  const lower = email.trim().toLowerCase();
  const at = lower.lastIndexOf('@');
  if (at < 0 || at === lower.length - 1) return false;
  const domain = lower.slice(at + 1);
  return BLOCKED_SIGNUP_EMAIL_DOMAINS.some((d) => domain === d.toLowerCase());
}
